import { SVGProps } from "react";

export function Sector(props: SVGProps<SVGSVGElement>): React.ReactElement {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.5 27C21.5 25.6193 20.3807 24.5 19 24.5C17.6193 24.5 16.5 25.6193 16.5 27H21.5ZM16.5 35C16.5 36.3807 17.6193 37.5 19 37.5C20.3807 37.5 21.5 36.3807 21.5 35H16.5ZM16.5 27V35H21.5V27H16.5Z"
        fill="black"
      />
      <path
        d="M47.5 27C47.5 25.6193 46.3807 24.5 45 24.5C43.6193 24.5 42.5 25.6193 42.5 27H47.5ZM42.5 35C42.5 36.3807 43.6193 37.5 45 37.5C46.3807 37.5 47.5 36.3807 47.5 35H42.5ZM42.5 27V35H47.5V27H42.5Z"
        fill="black"
      />
      <mask id="path-3-inside-1_261_14228" fill="white">
        <rect y="12" width="64" height="47" rx="4" />
      </mask>
      <rect
        y="12"
        width="64"
        height="47"
        rx="4"
        stroke="black"
        strokeWidth="10"
        mask="url(#path-3-inside-1_261_14228)"
      />
      <path d="M2 31H62" stroke="black" strokeWidth="5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 12V10H43V12H48V9C48 6.79086 46.2091 5 44 5H20C17.7909 5 16 6.79086 16 9V12H21Z"
        fill="black"
      />
    </svg>
  );
}
